import { type AvatarSizeMap } from './types';

export const AVATAR_SIZES: AvatarSizeMap = {
	xxsmall: 16,
	xsmall: 16,
	UNSAFE_xsmall: 20,
	small: 24,
	medium: 32,
	large: 40,
	xlarge: 96,
	xxlarge: 128,
};
